// src/components/study/Study.tsx
// =====================================================================
// MODAL DE REFERÊNCIAS - IDENTIDADE GRAIA
// Exibe as referências cadastradas no card
// =====================================================================

import React from 'react';
import { X, BookOpen } from 'lucide-react';
import './ReferencesStudy.css';

interface ReferencesModalProps {
    isOpen: boolean;
    onClose: () => void;
    references: string;
}

const ReferencesStudy: React.FC<ReferencesModalProps> = ({
    isOpen,
    onClose,
    references
}) => {
    if (!isOpen) return null;

    // Renderizar HTML das referências
    const renderReferences = () => {
        return { __html: references };
    };

    return (
        <div className="references-modal-overlay" onClick={onClose}>
            <div className="references-modal-container" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="references-modal-header">
                    <div className="references-modal-title-wrapper">
                        <BookOpen size={20} className="references-modal-icon" />
                        <h3 className="references-modal-title">Referências</h3>
                    </div>
                    <button
                        className="references-modal-close"
                        onClick={onClose}
                        aria-label="Fechar"
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Body */}
                <div className="references-modal-body">
                    {references && references.trim() ? (
                        <div
                            className="references-content"
                            dangerouslySetInnerHTML={renderReferences()}
                        />
                    ) : (
                        <div className="references-empty">
                            <BookOpen size={48} className="references-empty-icon" />
                            <p>Nenhuma referência cadastrada</p>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="references-modal-footer">
                    <button
                        className="references-btn-close"
                        onClick={onClose}
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReferencesStudy;